interface ToggleSwitchProps {
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
  onLabel?: string;
  offLabel?: string;
  className?: string;
}

export default function ToggleSwitch({
  label,
  value,
  onChange,
  onLabel = '수신',
  offLabel = '거부',
  className = '',
}: ToggleSwitchProps) {
  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      <label className="block text-sm font-medium text-gray-700">{label}</label>
      <button
        onClick={() => onChange(!value)}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors cursor-pointer ${
          value ? 'bg-blue-600' : 'bg-gray-200'
        }`}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
            value ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </button>
      <span className="text-sm text-gray-600">
        {value ? onLabel : offLabel}
      </span>
    </div>
  );
}
